{
  "AGENT_BOTS": {
    "HEADER": "Boti",
    "LOADING_EDITOR": "Načítám editor...",
    "DESCRIPTION": "Agent Boti jsou jako ti nejúžasnější členové vašeho týmu. Mohou vyřídit drobnosti, abyste se vy mohli soustředit na to, co je důležité. Vyzkoušejte je. Své boty můžete spravovat z této stránky nebo vytvářet nové pomocí tlačítka 'Nakonfigurovat nového bota'.",
    "LEARN_MORE": "Zjistěte více o agent botech",
    "GLOBAL_BOT": "Systémový bot",
    "GLOBAL_BOT_BADGE": "Systémový",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar bota byl úspěšně smazán",
      "ERROR_DELETE": "Chyba při mazání avataru bota, zkuste to znovu"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Jméno bota",
        "PLACEHOLDER": "Pojmenujte svého bota.",
        "ERROR": "Jméno bota je povinné."
      },
      "DESCRIPTION": {
        "LABEL": "Popis bota",
        "PLACEHOLDER": "Co tento bot dělá?"
      },
      "BOT_CONFIG": {
        "ERROR": "Zadejte prosím konfiguraci vašeho CSML bota výše.",
        "API_ERROR": "Vaše CSML konfigurace je neplatná. Opravte ji a zkuste to znovu."
      },
      "SUBMIT": "Ověřit a uložit"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Vybrat bota",
      "DESC": "Přiřaďte Bota k vaší schránce. Mohou zvládat úvodní konverzace a předávat je lidskému agentovi.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Aktualizovat",
      "DISCONNECT": "Odpojit bota",
      "SUCCESS_MESSAGE": "Agent bot byl úspěšně aktualizován.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Agent bot byl úspěšně odpojen.",
      "ERROR_MESSAGE": "Nepodařilo se aktualizovat agent bota. Zkuste to znovu.",
      "DISCONNECTED_ERROR_MESSAGE": "Nepodařilo se odpojit agent bota. Zkuste to znovu.",
      "SELECT_PLACEHOLDER": "Vybrat bota",
      "COUNTRY_BOTS": {
        "TITLE": "Boti podle země",
        "DESC": "Tato schránka obsluhuje více zemí. Konverzace jde na bota své země: podle obchodu Kauflandu, podle trhu objednávky z Allegra, jinak podle jazyka, kterým zákazník píše. Ostatní konverzace jdou na výchozího bota výše.",
        "COUNTRY": "Vyberte zemi",
        "BOT": "Vyberte bota",
        "ADD": "Přidat bota pro zemi",
        "REMOVE": "Odebrat",
        "DEFAULT_REQUIRED": "Nejdřív vyberte výchozího bota. Bot země ho nahrazuje jen pro svou zemi.",
        "DISCONNECT_ALL": "Odpojit všechny boty"
      }
    },
    "ADD": {
      "TITLE": "Konfigurovat nového bota",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "API": {
        "SUCCESS_MESSAGE": "Bot byl úspěšně přidán.",
        "ERROR_MESSAGE": "Nepodařilo se přidat bota. Zkuste to později znovu."
      }
    },
    "LIST": {
      "404": "Nebyli nalezeni žádní boti. Můžete vytvořit bota kliknutím na tlačítko 'Konfigurovat nového bota' ↗",
      "LOADING": "Načítám boty...",
      "TYPE": "Typ bota",
      "TABLE_HEADER": {
        "DETAILS": "Detaily bota",
        "URL": "URL webhooku"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "TITLE": "Smazat bota",
      "SUBMIT": "Vymazat",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "DESCRIPTION": "Jste si jisti, že chcete smazat tohoto bota? Tato akce je nevratná.",
      "CONFIRM": {
        "TITLE": "Potvrdit smazání",
        "MESSAGE": "Opravdu chcete smazat {name}?",
        "YES": "Ano, smazat",
        "NO": "Ne, ponechat"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot byl úspěšně smazán.",
        "ERROR_MESSAGE": "Nepodařilo se smazat bota. Zkuste to znovu."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Upravit",
      "LOADING": "Načítám boty...",
      "TITLE": "Upravit bota",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "API": {
        "SUCCESS_MESSAGE": "Bot byl úspěšně aktualizován.",
        "ERROR_MESSAGE": "Nepodařilo se aktualizovat bota. Zkuste to znovu."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar bota"
      },
      "NAME": {
        "LABEL": "Jméno bota",
        "PLACEHOLDER": "Zadejte jméno bota",
        "REQUIRED": "Jméno bota je povinné"
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "Co tento bot dělá?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL webhooku",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "URL webhooku je povinná"
      },
      "ERRORS": {
        "NAME": "Jméno bota je povinné",
        "URL": "URL webhooku je povinná",
        "VALID_URL": "Zadejte prosím platnou URL začínající na http:// nebo https://"
      },
      "CANCEL": "Zrušit",
      "CREATE": "Vytvořit bota",
      "UPDATE": "Aktualizovat bota"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Nakonfigurujte webhook bota pro integraci s vašimi vlastními službami. Bot bude přijímat a zpracovávat události z konverzací a může na ně odpovídat."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
